import { Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IonToggle } from '@ionic/angular/standalone';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';

@Component({
  selector: 'fv-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [
    IonicComponentsModule
  ],
  standalone: true
})
export class CheckboxComponent  implements ControlValueAccessor {

  //#region Propiedades

  private _value: string
  public get value(): string {
    return this._value
  }
  @ViewChild("input") public input: IonToggle
  @Input("value") public set value(val: string) {
    this._value = val
  }
  @Output("valueChange") public valueChange = new EventEmitter<{newValue: string, oldValue: string}>()
  @Input("label") public label: string
  @Input("readonly") public readonly: boolean = false
  @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano.

  //#endregion

  //#region Constructor

  constructor(
    @Self() @Optional() private control: NgControl
  ) {
    this.control.valueAccessor = this
  }

  //#endregion

  //#region Eventos

  public onToggleChange(): void {
    let oldValue = this._value
    let currentValue: string
    if (this.input.checked) {
      currentValue = "True"
    } else {
      currentValue = "False"
    }
    if (this._value != currentValue) {
      this.value = currentValue
      this.onChange(this.value)
      this.valueChange.emit({newValue: this.value, oldValue: oldValue})
    }
    this.onTouched()
  }

  //#endregion

  //#region ReactiveForms

  private onChange = (value: string) => {}
  private onTouched = () => {}

  writeValue(value: string): void {
    let oldValue = this._value
    this.value = value
    this.valueChange.emit({newValue: value, oldValue: oldValue})
    this.onChange(value)
  }

  registerOnChange(fn: (value: string) => {}): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  public isInvalid(): boolean {
    return this.control ? this.control.invalid : false
  }

  public isTouched(): boolean {
    return this.control ? this.control.touched : false
  }

  //#endregion

}
